import getClientsMin from './getClientsMin'

export const getClientsMinPromise = getClientsMin
